import React from "react";
import { Button, Link, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { goToDashboard } from "@helpers/mainAppUrls";
import { SendEventType } from "../stateMachine/typings/SendEventType";
import { SpacerBottom } from "./SpacerBottom";

export interface Props {
  sendEvent: SendEventType;
}

export const Deactivated = ({ sendEvent }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h4" component="h1" mb={6}>
        {t("netfondsConsent.deactivated")}
      </Typography>

      <Typography variant="body1" mb={8}>
        <Trans i18nKey="netfondsConsent.howToActivate">
          Sie können den Datenimport jederzeit in Ihrem
          <Link
            href={`${import.meta.env.VITE_APP_ROOT_URL}/user/resetPassword`}
            underline="hover"
          >
            Cashback-Dashboard
          </Link>
          aktivieren.
        </Trans>
      </Typography>

      <SpacerBottom spacing={2}>
        <Button variant="primary" onClick={() => goToDashboard()}>
          {t("netfondsConsent.done")}
        </Button>
      </SpacerBottom>

      <Button variant="tertiary" onClick={() => sendEvent({ type: "BACK" })}>
        {t("netfondsConsent.changedYourMind")}
      </Button>
    </>
  );
};
